import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiChevronDown } from 'react-icons/fi';

const faqs = [
  {
    q: "Do I need a consultation first?",
    a: "For large, custom, or cover-up pieces, a consultation is highly recommended and often required. This allows the artist to measure the area, discuss your vision, and take reference photos. For smaller, simpler pieces, we can often skip the in-person consultation and handle details via email."
  },
  {
    q: "How should I prepare for my appointment?",
    a: "Get a good night's sleep, eat a solid meal 1-2 hours before your appointment, and stay hydrated. Do not consume alcohol or blood-thinning medication 24 hours prior. Wear comfortable clothing that allows easy access to the area being tattooed."
  },
  {
    q: "Do you accept walk-ins?",
    a: "Yes, we accept walk-ins for smaller pieces based on artist availability. However, to guarantee a spot, we strongly recommend booking an appointment in advance."
  },
  {
    q: "How much does a tattoo cost?",
    a: "Our shop minimum is CA$120. Final prices vary greatly based on size, detail, placement, and the specific artist. Check our Pricing page for a general guide, or book a consultation for an accurate quote."
  },
  {
    q: "What is your deposit policy?",
    a: "We require a CA$100 non-refundable deposit to secure an appointment and begin drawing custom designs. The deposit goes towards the final cost of your tattoo. 48 hours notice is required to reschedule without losing your deposit."
  },
  {
    q: "How long is the healing process?",
    a: "Initial surface healing takes about 2-3 weeks, during which you must follow strict aftercare protocols (no swimming, sun exposure, or picking). Complete healing beneath the skin can take 2-3 months."
  },
  {
    q: "Do you do cover-ups?",
    a: "Yes. Cover-ups require an in-person consultation so we can assess the existing tattoo's darkness, scar tissue, and placement to determine what is realistically possible."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="pt-24 pb-20 bg-background min-h-screen">
      <div className="container mx-auto px-6 max-w-4xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-6xl font-display mb-6">FAQ</h1>
          <div className="w-20 h-1 bg-secondary mx-auto mb-6"></div>
          <p className="text-muted">Everything you need to know before stepping into the studio.</p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.1 }}
              className="bg-primary border border-gray-800 rounded-sm overflow-hidden"
            >
              <button
                className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <span className="font-medium text-light text-lg">{faq.q}</span>
                <SafeIcon 
                  icon={FiChevronDown} 
                  className={`text-secondary transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} 
                />
              </button>
              
              <AnimatePresence>
                {openIndex === idx && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-6 pb-5 text-muted leading-relaxed border-t border-gray-800 pt-4">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;